/**
 * GroupNameLink
 */
import React from 'react';
import { connect } from 'react-redux';

// Components
import GroupName from '../GroupName';

// Actions
import { updateQueryString } from '../../services/router/actions';

interface Props {
    groupId?: ?number;
    updateQueryString: Function;
}

export class GroupNameLink extends React.PureComponent<Props> {
    handleClick = (event: SyntheticEvent<EventTarget>) => {
        event.preventDefault();
        event.stopPropagation();
        const { groupId } = this.props;
        this.props.updateQueryString({
            groupModal: true,
            selectedGroup: groupId
        });
    };

    render() {
        const { groupId } = this.props;
        if (!groupId) return null;
        /* eslint-disable */
        return (
            <a href="#" onClick={this.handleClick}>
                <GroupName groupId={groupId} />
            </a>
        );
        /* eslint-enable */
    }
}

export default connect(
    null,
    { updateQueryString }
)(GroupNameLink);
